import script from "./StockBasicView.vue?vue&type=script&setup=true&lang=js"
export * from "./StockBasicView.vue?vue&type=script&setup=true&lang=js"

import "./StockBasicView.vue?vue&type=style&index=0&id=eb177c2e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb177c2e"]])

export default __exports__